// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import { HelmetProvider } from 'D:/泰诺能源/nengyuan-yaokong/terra-ems-web-main-yaokong/node_modules/.pnpm/@umijs+renderer-react@4.6.2_031ce76bd072575f474afb3c4c4bdad4/node_modules/@umijs/renderer-react';
import { context } from './helmetContext';

export const innerProvider = (container) => {
  return React.createElement(HelmetProvider, { context }, container);
}
